import { call, put } from 'redux-saga/effects';
import { config } from '../../api/config';
import { Api } from '../../api/api';
import { actions } from '..';
import { downloadFile, errorMessage } from '../../utils';

export function* getAffiliateInvitesSaga({ body: initialBody }) {
  try {
    yield put(actions.affiliate.setAffiliateLoadingAction(true));

    const body = {
      ...initialBody,
      limit:
        initialBody && initialBody.limit != null
          ? initialBody.limit
          : config.DEFAULTS.recordsPerPage,
    };

    const { affiliate_invites, count, header } = yield call(
      Api.getAffiliateInvites,
      body
    );

    yield put(
      actions.affiliate.setAffiliateInvitesAction(
        affiliate_invites || [],
        count ?? 0,
        header || {}
      )
    );
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.affiliate.setAffiliateLoadingAction(false));
  }
}

export function* exportAffiliateInvitesSaga({ filename }) {
  try {
    yield put(actions.download.setXlsLoadingAction(true));

    const response = yield call(Api.exportAffiliateInvites);

    downloadFile(response, filename);
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.download.setXlsLoadingAction(false));
  }
}

export function* getAffiliateSettingsSaga() {
  try {
    yield put(actions.affiliate.setAffiliateSettingsLoadingAction(true));

    const settings = yield call(Api.getAffiliateSettings);

    yield put(actions.affiliate.setAffiliateSettingsAction(settings));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.affiliate.setAffiliateSettingsLoadingAction(false));
  }
}

export function* updateAffiliateSettingsSaga({ body, onSuccess }) {
  try {
    yield put(actions.affiliate.setAffiliateSettingsSavingAction(true));

    const settings = yield call(Api.updateAffiliateSettings, body);

    yield put(actions.affiliate.setAffiliateSettingsAction(settings));
    if (typeof onSuccess === 'function') {
      onSuccess(settings);
    }
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.affiliate.setAffiliateSettingsSavingAction(false));
  }
}
